import OutreachRequestStatus from "./OutreachRequestStatus";

export default class CreateOutreachRequestStatusRequest {
  Status: OutreachRequestStatus = new OutreachRequestStatus();
  SendEmail: boolean = false;
  Note: string = "";
}
